import { getWorkspaceId } from "./getCredentials";
import { requestFromToggl } from "./requestFromToggl";

export function getWeeklyTimeEntries(mondayDate, successCb, failCb) {
  const url = `https://api.track.toggl.com/reports/api/v3/workspace/${getWorkspaceId()}/search/time_entries`;
  const method = "POST";

  // get the date of the last monday

  const lastMondayString = mondayDate.toISOString().split("T")[0];

  // end date is friday
  const lastFriday = new Date(mondayDate);
  lastFriday.setDate(lastFriday.getDate() + 4);
  const lastFridayString = lastFriday.toISOString().split("T")[0];

  const body = {
    // audit: {
    //   group_filter: {
    //     currency: "string",
    //     max_amount_cents: "integer",
    //     max_duration_seconds: "integer",
    //     min_amount_cents: "integer",
    //     min_duration_seconds: "integer",
    //   },
    //   show_empty_groups: "boolean",
    //   show_tracked_groups: "boolean",
    // },
    // billable: true,
    // client_ids: ["integer"],
    // description: "string",
    end_date: lastFridayString,
    // group_ids: ["integer"],
    // grouping: "string",
    // include_time_entry_ids: "boolean",
    // max_duration_seconds: "integer",
    // min_duration_seconds: "integer",
    // postedFields: ["string"],
    // project_ids: ["integer"],
    // rounding: "integer",
    // rounding_minutes: "integer",
    // startTime: "string",
    start_date: lastMondayString,
    // sub_grouping: "string",
    // tag_ids: ["integer"],
    // task_ids: ["integer"],
    // user_ids: ["integer"],
  };
  requestFromToggl(url, method, body, successCb, failCb);
}
